<div class="notification-bell-container">
  <button 
    mat-icon-button 
    class="notification-button"
    (click)="toggleDropdown()"
    [matBadge]="unreadCount > 0 ? (unreadCount > 99 ? '99+' : unreadCount) : null"
    matBadgeColor="warn"
    matBadgeOverlap="true"
    [matBadgeHidden]="unreadCount === 0"
    aria-label="Notifications">
    <mat-icon>notifications</mat-icon>
  </button>

  <!-- Custom Dropdown (not mat-menu) -->
  @if (showDropdown) {
    <div class="notification-dropdown">
      <div class="dropdown-header">
        <div class="header-left">
          <h3>Notifications</h3>
          @if (unreadCount > 0) {
            <span class="unread-badge">{{ unreadCount }} unread</span>
          }
        </div>
        <div class="header-actions">
          @if (unreadCount > 0) {
            <button 
              mat-button 
              class="read-all-button"
              (click)="markAllAsRead()"
              [disabled]="isMarkingAllAsRead"
              aria-label="Mark all notifications as read">
              <mat-icon>done_all</mat-icon>
              <span>Read all</span>
            </button>
          }
          <button 
            mat-icon-button 
            class="close-button"
            (click)="toggleDropdown()"
            aria-label="Close notifications">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
      
      <div class="notification-list">
        @if (notifications.length === 0) {
          <div class="empty-state">
            <mat-icon>notifications_none</mat-icon>
            <p>No notifications</p>
          </div>
        } @else {
          @for (notification of notifications; track notification.id) {
            <div 
              class="notification-item"
              [class.unread]="!notification.is_read"
              (click)="onNotificationClick(notification)">
              <div class="notification-content">
                @if (!notification.is_read) {
                  <span class="unread-dot"></span>
                }
                <div class="notification-text">
                  <p class="notification-message" [class.bold]="!notification.is_read">
                    {{ notification.message }}
                  </p>
                  <span class="notification-time">{{ formatTimestamp(notification.created_at) }}</span>
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  }
</div>
